import { ApiHandler } from '@eshop/api-client'

import type { ArticleObject } from '#/local/component/ArticleList'

import { Config } from '#/global/helper/Config'

export const fetchArticleListByQuery = async ({ page, query }: { page: number, query: string }) => {
    const api = new ApiHandler({
        apiEndpoint: 'search',
        path: '/v2/{company}/search',
        pathParameters: {
            company: Config.getSearchCompany(),
        },
        parameters: {
            query,
            engines: `articles`,
            page: page.toString(),
            items_per_page: '20',
        },
    })

    interface Fetch { num_documents_total: number, results: ArticleObject[] }
    const result = await api.send<Fetch[]>()
    const articles = result?.shift() ?? { num_documents_total: 0, results: [] }

    return {
        list: articles.results,
        itemsCount: articles.num_documents_total,
    }
}
